import { api } from '@/lib/apiClient'
import { extractApiStatus } from '@/lib/apiError'
import type { Envelope } from '@/lib/apiTypes'

/**
 * GET /account/onboarding — 404 NOT_FOUND tant que le compte n'a pas répondu.
 * POST /account/onboarding — 201 au premier enregistrement, 200 si déjà répondu.
 * Le corps du 200 est ignoré par le back : la fiche stockée est renvoyée.
 */
export interface OnboardingAnswers {
  personas: string[]
  personaOther: string | null
  propertyTypes: string[]
  pace: string | null
  paceOther: string | null
  missingFeature: string | null
}

export interface OnboardingRecord extends OnboardingAnswers {
  answeredAt: string | null
}

export async function getOnboarding(): Promise<OnboardingRecord | null> {
  try {
    const res = await api.get<Envelope<OnboardingRecord>>('/account/onboarding')
    return res.data.data
  } catch (err: unknown) {
    if (extractApiStatus(err) === 404) return null
    throw err
  }
}

export async function submitOnboarding(
  answers: OnboardingAnswers,
): Promise<{ record: OnboardingRecord; created: boolean }> {
  const res = await api.post<Envelope<OnboardingRecord>>('/account/onboarding', answers)
  return { record: res.data.data, created: res.status === 201 }
}
